import { makeEventFunctions } from '@deephaven/golden-layout';
var NavigationEvent = Object.freeze({
  CYCLE_TO_NEXT_STACK: 'NavigationEvent.CYCLE_TO_NEXT_STACK',
  CYCLE_TO_PREVIOUS_STACK: 'NavigationEvent.CYCLE_TO_PREVIOUS_STACK',
  CYCLE_TO_NEXT_TAB: 'NavigationEvent.CYCLE_TO_NEXT_TAB',
  CYCLE_TO_PREVIOUS_TAB: 'NavigationEvent.CYCLE_TO_PREVIOUS_TAB'
});
var _makeEventFunctions = makeEventFunctions(NavigationEvent.CYCLE_TO_NEXT_STACK),
  listenForCycleToNextStack = _makeEventFunctions.listen,
  emitCycleToNextStack = _makeEventFunctions.emit,
  useCycleToNextStackListener = _makeEventFunctions.useListener;
export { listenForCycleToNextStack, emitCycleToNextStack, useCycleToNextStackListener };
var _makeEventFunctions2 = makeEventFunctions(NavigationEvent.CYCLE_TO_PREVIOUS_STACK),
  listenForCycleToPreviousStack = _makeEventFunctions2.listen,
  emitCycleToPreviousStack = _makeEventFunctions2.emit,
  useCycleToPreviousStackListener = _makeEventFunctions2.useListener;
export { listenForCycleToPreviousStack, emitCycleToPreviousStack, useCycleToPreviousStackListener };
var _makeEventFunctions3 = makeEventFunctions(NavigationEvent.CYCLE_TO_NEXT_TAB),
  listenForCycleToNextTab = _makeEventFunctions3.listen,
  emitCycleToNextTab = _makeEventFunctions3.emit,
  useCycleToNextTabListener = _makeEventFunctions3.useListener;
export { listenForCycleToNextTab, emitCycleToNextTab, useCycleToNextTabListener };
var _makeEventFunctions4 = makeEventFunctions(NavigationEvent.CYCLE_TO_PREVIOUS_TAB),
  listenForCycleToPreviousTab = _makeEventFunctions4.listen,
  emitCycleToPreviousTab = _makeEventFunctions4.emit,
  useCycleToPreviousTabListener = _makeEventFunctions4.useListener;
export { listenForCycleToPreviousTab, emitCycleToPreviousTab, useCycleToPreviousTabListener };
export default NavigationEvent;
//# sourceMappingURL=NavigationEvent.js.map